
import WidgetMixins from '@/mixins/WidgetMixins';
import Component, { mixins } from 'vue-class-component';
import AuthLayout, { IPanelRow } from './components/AuthLayout.vue';
import { brandName } from '@/utils/brand';

@Component({
  components: {
    AuthLayout,
  },
})
export default class MigrateAccount extends mixins(WidgetMixins) {
  get brandName(): string {
    return brandName();
  }

  panelRows: IPanelRow[] = [
    {
      icon: 'sync_alt',
      title: 'Seamless migration',
      text: 'Your contacts, groups and reports move with you.',
    },
    {
      icon: 'storefront',
      title: 'Business features',
      text: 'Sender IDs, sub-accounts and reseller options.',
    },
  ];
}
